<template>
  <div>
    <b-row>
      <div v-if="loading">
        <loader></loader>
      </div>
      <b-col sm="6">
        <Ticket/>
      </b-col>
      <b-col sm="6">
        <Observaciones :company_id="company_id" :is_new="is_new" :subject="subject"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";

import sampleData from "./_data2";
import { ClientTable, Event } from "vue-tables-2";
import { mapState, mapActions, mapMutations } from "vuex";
import loader from "./../../containers/loader";
import Treeselect from "@riophae/vue-treeselect";
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import Ticket from './Ticket'
import Observaciones from './Observaciones'
Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
  events: "change",
});
Validator.localize("es", es);

//Vue.use(ClientTable)

export default {
  name: "detalle-tickets",
  props: {
    id: {
      type: [Number,String],
      required: true
    },
    company_id: {
      type: [Number,String],
      required: true
    },
    is_new: {
      type: Boolean,
      required: false,
      default: false
    },
    subject: {
      type: [Number,String],
      required: false,
      default: 0
    }
  },
  components: {
    ClientTable,
    Event,
    loader,
    Treeselect,
    Ticket,
    Observaciones
  },
  data: function () {
    return {
      columns: ["nombre", "obervacion"],
      data: sampleData,
      loading: false,
      options: {
        headings: {
          asunto: "Asunto",
          nombre: "Nombre",
          email: "Email",
          responsable: "responsable",
        },
        sortable: ["Asunto", "Nombre"],
        filterable: ["asunto", "nombre"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
    };
  },
  async created() {
    await  this.verDetalle().then(async () =>{
      if (this.ticket_detalle.temporary_location_id){
        this.ticket_detalle.digit_location = true;
      }
    });
  },
  computed: {
    ...mapState("tickets", [
      "selectedTicket",
      "ticket_detalle",
      "selectedObservacion",
      "asignacionTicket",
      "observaciones",
      "esAdmin",
      "esEmpresa",
      "esSuperAdmin",
      "estados",
      "usuarios",
      "leido",
    ]),
    ...mapState('autenticacion', ['usuarioAdmin','usuarioEmpresa']),
    ...mapState("location", ["arbolUbicaciones"]),
  },
  methods: {
    ...mapActions("tickets", [
      "actualizarVisto",
      "detallarTicket"
    ]),
    ...mapActions("location", ["arbolUbicacionesEmpresa"]),
    ...mapActions("dashboard", ['notificationsUnread']),
    ...mapMutations("tickets", [
      "resetObservacion",
      "setObservaciones",
      "marcarLeido"
    ]),
    async verDetalle() {
      if (!this.usuarioAdmin && !this.usuarioTecnico) {
        this.marcarLeido();
        await this.actualizarVisto(this.id);
      }
      this.company_id && (await this.arbolUbicacionesEmpresa(this.company_id));
      await this.detallarTicket(this.id);
      await this.notificationsUnread();
    },
  },
  beforeDestroy() {
    this.resetObservacion();
    this.setObservaciones([]);
  },
};
</script>

<style scoped>
.mensajes {
  width: 95%;
  margin: auto;
  background: #72dbee9f;
  height: auto;
  padding: 25px;
  margin-top: 5px;
  border-radius: 10px;
}

.detalle_chat {
  font-size: 10pt;
  font-style: italic;
  font-weight: bold;
}

.chat {
  text-align: justify;
  font-size: 12pt;
}
.icon {
  margin-right: 5px;
}

.scroll {
  height: 500px;
  overflow-y: scroll;
}
</style>
